import store from "./store";
import { pageSetErrorDialogOpen } from "../actions/pageActions";

let Sentry;

if (__ERROR_REPORTING__) {
	import("@sentry/react").then((module) => {
		Sentry = module.default;
	});
}

const NETWORK_ERROR_MSG = "Network Error";

function isNetworkError(err) {
	return err.message === NETWORK_ERROR_MSG && !err.response;
}

function isServerFailure(err) {
	return err && err.response && err.response.status >= 500 && err.response.status <= 599;
}

export default function handleUnknownError(err, showDialog = true) {
	if (err.handled || err.validation) {
		if (__DEV__) {
			console.info("Ignoring handled error", err);
		}

		return;
	}

	if (isNetworkError(err)) {
		if (__DEV__) {
			console.info("Ignoring network error", err);
		}

		return;
	}

	console.error(err);
	if (__ERROR_REPORTING__) {
		Sentry.captureException(err);
		if (!isServerFailure(err) && showDialog) {
			Sentry.showReportDialog();
		}
	} else if (!isServerFailure(err) && showDialog && !store.getState().page.errorDialogOpen) {
		store.dispatch(pageSetErrorDialogOpen(true));
	}
}
